import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FTSMonthlyFilter = _resolveComponent("FTSMonthlyFilter")!
  const _component_FTSMonthlyTable = _resolveComponent("FTSMonthlyTable")!
  const _component_AggregatedPageWrapper = _resolveComponent("AggregatedPageWrapper")!

  return (_ctx.isAccessAllowed)
    ? (_openBlock(), _createBlock(_component_AggregatedPageWrapper, {
        key: 0,
        title: "Запрос по базе ФТС (месяц)",
        exportConfig: _ctx.getExportConfig
      }, {
        filter: _withCtx(() => [
          _createVNode(_component_FTSMonthlyFilter, {
            defaultFilter: _ctx.defaultFilter,
            onSearchFilter: _ctx.searchFilter,
            onUpdateFilter: _ctx.updateFilter,
            readonlyPermissionCode: _ctx.getPermissions.build,
            exportConfig: _ctx.getExportConfig
          }, null, 8, ["defaultFilter", "onSearchFilter", "onUpdateFilter", "readonlyPermissionCode", "exportConfig"])
        ]),
        table: _withCtx(() => [
          _createVNode(_component_FTSMonthlyTable, { filter: _ctx.getNormalizedFilters }, null, 8, ["filter"])
        ]),
        _: 1
      }, 8, ["exportConfig"]))
    : _createCommentVNode("", true)
}